
import { useTranslation } from "react-i18next"
import { Ref, forwardRef, useImperativeHandle, useState } from "react"

import { Box, Icon, List, ListItem, Tooltip, Typography } from "@mui/material"
import { CustomTable } from "../../../../../../components"
import { icons } from "../../../../../../utils/icons"
import { useStepStyles } from "./stepStyles"

type Step1Props = {
  row: Record<string, string>[]
  /* handleDisabled: StepManagementChildren['handleDisabledStep'] */
  selects: (number | string)[]
  userSeclecteds: (selects: (string | number)[]) => void
  message?: JSX.Element | undefined
  addMessage?: boolean
}

type Step1Ref = {
  getSelects: () => (number | string)[]
  restart: () => void
}

const AddUsersStep = forwardRef((props: Step1Props, ref: Ref<Step1Ref>) => {
  const { t } = useTranslation()
  const [selects, setSelects] = useState<(number | string)[]>(props.selects)
  const styles = useStepStyles()
  const columnsPermissions = [
    {
      id: 'users',
      label: t('general.tags.name'),
    },
    {
      id: 'role',
      label: t('general.tags.role'),
    },
    {
      id: 'area',
      label: t('general.tags.area'),
      renderCell: (params: any) => {
        const areaArray = params.current ? params.current.split(',').map((item:string) => item.trim()):undefined;
        const firstTwoAreas = areaArray?.slice(0, 2);
        const remainingAreas = areaArray?.slice(2);
        return (
          <Box /* sx={styles.containerArea} */>
            <Typography  sx={styles.areaTitle}>
              {firstTwoAreas?.join(', ')}
              {remainingAreas?.length > 0 && (
                <Tooltip
                  title={
                    <List>
                      {remainingAreas.map((item:string, index:number) => (
                        <ListItem key={index} style={{ padding: 0 }}>
                          {item}
                        </ListItem>
                      ))}
                    </List>
                  }
                >
                  <Icon sx={styles.viewMore}>{icons('add')}</Icon>
                </Tooltip>
              )}
              {!areaArray && 'N/A'}
            </Typography>
          </Box>
        )
      },
    },
    {
      id: 'department',
      label: t('general.tags.department'),
      renderCell: (params: any) => {
        const departmentArray = params.current ? params.current.split(',').map((item:string) => item.trim()):undefined;
        const firstTwoDepartments = departmentArray?.slice(0, 2);
        const remainingDepartments = departmentArray?.slice(2);
        return (
          <Box /* sx={styles.containerStatus} */>
            <Typography sx={styles.areaTitle}>
              {firstTwoDepartments?.join(', ')}
              {remainingDepartments?.length > 0 && (
                <Tooltip
                  title={
                    <List>
                      {remainingDepartments.map((item:string, index:number) => (
                        <ListItem key={index} style={{ padding: 0 }}>
                          {item}
                        </ListItem>
                      ))}
                    </List>
                  }
                >
                  <Icon sx={styles.viewMore}>{icons('add')}</Icon>
                </Tooltip>
              )}
              {!departmentArray && 'N/A'}
            </Typography>
          </Box>
        )
      },
    },
    {
      id: 'division',
      label: t('general.tags.division'),
    }
  ]

  useImperativeHandle(ref, () => ({
    getSelects: () => selects,
    restart: () => { setSelects([]) }
  }))

  const handleSelects = (value: number[]) => {
    /* props.handleDisabled(!value?.length) */
    props.userSeclecteds(value)
    setSelects(value)
  }

  return (
    <Box sx={{
      '& .table-container.table-container': {
        maxHeight: 'calc(90vh - 280px)'
      }
    }}>
      {
        !props.message && (
          <CustomTable
            tableChecks
            defaulPagination={20}
            defaultChecks={selects}
            onClick={(e) => { handleSelects(e.checks ?? []) }}
            name="Informe General"
            dontRefresh
            column={columnsPermissions}
            row={props.row ?? []}
            selected={-1}
            noContent={t('filesManager.messages.notFindUsers')}
            iconsNoContent={icons('userAccount')}
          />
        )
      }
      {(!!props.message && !!props?.addMessage) && props.message}
    </Box>
  )
}
)

export type { Step1Ref }
export { AddUsersStep }